import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Trainingsplan from "../views/Trainingsplan";
import Vorstand from "../views/Vorstand";
import BeitrageUGebuhren from "../views/BeitrageUGebuhren";
import FormulareUDownloads from "../views/FormulareUDownloads";
import Impressum from "../views/Impressum";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "",
        component: Home,
        meta: { title: "Judo in Garbsen - SC Budokwai Garbsen e.V." },
    },
    {
        path: "/trainingsplan",
        name: "Trainingsplan",
        component: Trainingsplan,
        meta: { title: "Trainingsplan - SC Budokwai Garbsen e.V." },
    },
    {
        path: "/vorstand",
        name: "Vorstand",
        component: Vorstand,
        meta: { title: "Unser Vorstand - SC Budokwai Garbsen e.V." },
    },
    {
        path: "/gebuhren",
        name: "Beiträge & Gebühren",
        component: BeitrageUGebuhren,
        meta: { title: "Beiträge & Gebühren - SC Budokwai Garbsen e.V." },
    },
    {
        path: "/downloads",
        name: "Formulare",
        component: FormulareUDownloads,
        meta: { title: "Formulare - SC Budokwai Garbsen e. V." },
    },
    {
        path: "/impressum",
        name: "Impressum",
        component: Impressum,
        meta: { title: "Impressum - SC Budokwai Garbsen e. V." },
    },
    {
        path: "/about",
        name: "About",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/About.vue"),
        meta: { title: "Über uns - SC Budokwai Garbsen e. V." },
    },
    { path: "*", redirect: "/" },
];

const router = new VueRouter({
    mode: "hash",
    routes,
});

// Update document title on navigation
router.beforeEach((to, from, next) => {
    const defaultTitle = "Judo in Garbsen";
    document.title = to.meta.title || defaultTitle;
    next();
});

export default router;
